import { render } from "./ResetPassword.vue?vue&type=template&id=4440bff0&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"

import "./ResetPassword.vue?vue&type=style&index=0&id=4440bff0&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/SIMI-TRAC/SIMI-TRAC-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4440bff0"]])

export default __exports__